import * as React from 'react';
import { Icon } from 'semantic-ui-react';

type componentState = {
    hasError: boolean;
}
class ComponentErrorBoundary extends React.PureComponent<{}, componentState> {
    constructor(props: any) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        console.error('Component render error:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return <Icon name="bug" />;
        }

        return this.props.children;
    }
}

export default ComponentErrorBoundary;
